import { PendingScore } from "./PendingScore";
import { hazardKeyLabel } from "@/lib/results";
import type { PerHazardHighRisk } from "@/lib/takeaways";

/**
 * Per-hazard high-risk percentages, one per line. Extracted verbatim from
 * TakeawayCards.tsx's PercentAtHighRiskCard so Tab 2 and the dashboard render
 * the same treatment from one place.
 *
 * Changing Precipitation gets one line per season (MAM, OND), never a
 * combined one.
 *
 * One line per hazard, not a comma-joined string: a single line reads as one
 * dense, unscannable value, and a list is what this data actually is.
 */
export function HazardPercentList({ perHazardPct }: { perHazardPct: PerHazardHighRisk[] }) {
  const allPending = perHazardPct.every((p) => p.pct === null);
  if (allPending) return <PendingScore />;

  return (
    <ul className="flex flex-col gap-1">
      {perHazardPct.map((p) => (
        <li key={p.key} className="flex items-baseline justify-between gap-2">
          <span className="text-xs text-muted-foreground">{hazardKeyLabel(p.key)}</span>
          <span className="text-sm font-semibold">{p.pct === null ? "—" : `${p.pct}%`}</span>
        </li>
      ))}
    </ul>
  );
}
